import React from 'react'

import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Link from '@material-ui/core/Link';

import WideoLogo from './img/WideoLogo.svg';

interface Props {
}

interface State { 
}

class Header extends React.Component<Props, State> {

  handleGoToWideo = (): void => {
    window.location.href = 'https://wideo.co';
  }  

  render() {
    return ( 
      <AppBar 
        color="inherit" 
        position="relative"
        elevation={0}
      >
        <Box
          boxShadow='0 2px 6px rgba(15,31,41,.08), 0 0 3px rgba(15,31,41,.04)'
          py={1}
        >
          <Toolbar>
            <Link
              component="div"
              style={{ cursor: 'pointer' }}
              onClick={this.handleGoToWideo}>
                <img 
                  alt="Wideo Logo"
                  src={WideoLogo}
                  height="30" 
                />
            </Link>
          </Toolbar>
        </Box>
        </AppBar>        
    );
  }

  }

export default Header;  